import React, { useState } from "react";
import "./AdminGallery.css";

const WEB_APP_URL =
  "https://script.google.com/macros/s/AKfycbxVWJccOKi8rej-aA6dFJ70LVxRMfCDgDKhdCzsk-M2Pfc4iZi_xTyOoNKuyhgWzgtO/exec";

export default function AdminGallery() {
  const [mediaType, setMediaType] = useState("image");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  // Reads the raw file structure seamlessly into a safe array format for Apps Script backend processing
  const fileToBlobData = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Keeps fallback format but handles chunk structures clearly
      reader.onload = () => {
        const base64Split = reader.result.split(",");
        resolve({
          base64: base64Split[1],
          mimeType: file.type
        });
      };
      reader.onerror = (error) => reject(error);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedFile) {
      setStatus({ type: "error", message: "❌ Please select a file first." });
      return;
    }

    // Gentle file-size safety guardrail reminder for Google Apps Script environments
    if (selectedFile.size > 25 * 1024 * 1024) {
      setStatus({ type: "error", message: "❌ Video is too large. Please keep files under 25MB for Google Drive scripts." });
      return;
    }

    try {
      setLoading(true);
      setStatus({ type: "info", message: "Processing and uploading your media..." });

      const fileData = await fileToBlobData(selectedFile);

      const payload = {
        type: "gallery",
        mediaUrl: fileData.base64, // Extracted clean string without prefix pollution
        mimeType: fileData.mimeType,
        fileName: selectedFile.name,
        mediaType: mediaType,
      };

      const response = await fetch(WEB_APP_URL, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: JSON.stringify(payload),
      });

      const resData = await response.json();

      if (resData.result === "success") {
        setStatus({
          type: "success",
          message: "✅ Media asset uploaded successfully!",
        });
        setSelectedFile(null);
        e.target.reset();
      } else {
        setStatus({ type: "error", message: `❌ Server error: ${resData.error || "Check Google Script Logs"}` });
      }

    } catch (err) {
      setStatus({ type: "error", message: "❌ Upload failed connection check." });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-gallery-page">
      <div className="admin-gallery-card">
        <h2 className="admin-gallery-title">Media Upload</h2>

        <form onSubmit={handleSubmit} className="admin-gallery-form">
          <h1 className="Gallery-title">Upload Gallery Images & Videos</h1>

          {/* Media Type */}
          <div>
            <label className="admin-gallery-label">Select Type</label>
            <select
              className="admin-gallery-select"
              value={mediaType}
              onChange={(e) => setMediaType(e.target.value)}
            >
              <option value="image">📸 Image / Photo</option>
              <option value="video">🎥 Video</option>
              <option value="reel">📱 Reel</option>
            </select>
          </div>

          {/* File Upload */}
          <div>
            <label className="admin-gallery-label">Choose File</label>
            <div className="upload-box">
              <input
                type="file"
                accept="image/*,video/*"
                onChange={(e) => setSelectedFile(e.target.files[0])}
              />
              <p>
                {selectedFile
                  ? `📁 ${selectedFile.name} (${(selectedFile.size / (1024 * 1024)).toFixed(1)} MB)`
                  : "Click here or drag & drop an image/video"}
              </p>
            </div>
          </div>

          {/* Upload Button */}
          <button type="submit" className="upload-btn" disabled={loading}>
            {loading ? "Uploading..." : "Upload Now"}
          </button>
        </form>

        {status.message && (
          <div
            className={`status-box ${
              status.type === "success"
                ? "status-success"
                : status.type === "error"
                ? "status-error"
                : "status-info"
            }`}
          >
            {status.message}
          </div>
        )}
      </div>
    </div>
  );
}